import { render } from "./submitForm.vue?vue&type=template&id=6b7a52dc&scoped=true"
import script from "./submitForm.js?vue&type=script&lang=js"
export * from "./submitForm.js?vue&type=script&lang=js"

import "./submitForm.vue?vue&type=style&index=0&id=6b7a52dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7a52dc"]])

export default __exports__